import clsx from "clsx";
import { type PropsWithChildren } from "react";

export type FormGroupGap = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16 | 20 | 24;

export interface FormGroupProps extends PropsWithChildren {
    direction?: "vertical" | "horizontal";
    gap?: FormGroupGap;
    isGrid?: boolean;
    className?: string;
    /** 网格列数 (仅当 isGrid 为 true 时有效) */
    columns?: 1 | 2 | 3 | 4 | 5 | 6 | 12;
}

export const FormGroup: React.FC<FormGroupProps> = ({
    className,
    isGrid = false,
    direction = "vertical",
    children,
    gap = 4,
    columns = 1
}) => {
    const gapClass = `gap-${gap}`;
    const gridColsClass = isGrid ? `grid-cols-${columns}` : "";

    return (
        <div className={clsx(
            isGrid ? "grid" : "flex",
            gapClass,
            isGrid && gridColsClass,
            !isGrid && (direction === 'vertical' ? "flex-col" : "flex-row"),
            className
        )}>
            {children}
        </div>
    )
}